import React from "react";
import AwardDetailTable from "./AwardDetailTable";
import ReportProgramsPage from "../../components/ReportProgramsPage";

const CocardAwardDetailIndex = () => (
  <ReportProgramsPage
    TableComponent={AwardDetailTable}
    loadingMessage="Loading Cocard award detail..."
  />
);

export default CocardAwardDetailIndex;
